import {Component, OnInit} from '@angular/core';
import {Carrier} from '../../../domain/carrier';
import {ShipmentService} from '../shipment.service';
import {Session} from '../../../domain/session';
import {PopupDialogBase} from '../../../component/popup-dialog-base';
import {MessageService} from '../../../component/message.service';
import {RequestExecutor} from '../../../util/request-executor';
import {Router} from '@angular/router';

@Component({
  selector: 'app-assign',
  templateUrl: './assign-order-carrier.component.html',
  styleUrls: ['./assign-order-carrier.component.css'],
  standalone: false
})
export class AssignOrderCarrierComponent extends PopupDialogBase implements OnInit {
  carriers: Carrier[];
  orderIds: string[];

  assigning = false;

  carrier: string = '';

  constructor(
    private request: RequestExecutor,
    private session: Session,
    private messageService: MessageService,
    private router: Router
  ) {
    super();
  }

  ngOnInit() {
    this.carriers = this.session.getCarriers().filter(value => value.Active);
  }

  cancel() {
    this.close();
  }

  assign() {
    this.assigning = true;

    this.request.post('/order/assign/batch', {OrderIds: this.orderIds, CarrierId: this.carrier === '' ? null : this.carrier})
      .then(() => {
        this.messageService.showBottomSuccessSnackBar('Sendingen' + (this.orderIds.length > 1 ? 'e' : '') + ' ble tildelt');

        this.close();
      })
      .catch(error => {
        if (error.status == 401) {
          this.router.navigate(['login']);
        } else {
          this.messageService.showBottomErrorSnackBar('Kunne ikke tildele sendingen' + (this.orderIds.length > 1 ? 'e' : ''));
        }
      })
      .finally(() => this.assigning = false);
  }
}
